import { Box } from '@material-ui/core';
import CollectiveitemsList from '../../../shared/CollectiveitemsList';

function CollectiveItemsBox({ isRTL, theme, words, height }) {
  return (
    <Box>
      <CollectiveitemsList
        isRTL={isRTL}
        words={words}
        height={height}
        theme={theme}
        color={undefined}
      ></CollectiveitemsList>
    </Box>
  );
}

export default CollectiveItemsBox;
